(ns hypnos.consumer.panels.consult.chronic-issues
  "The consult chronic issues step."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:on-click (fn [_] (nav-fn state :chronic-issues :next))}
     (tr :ui.label/next)]]
   [:p.control
    [:button.button.is-rounded.is-light
     {:on-click (fn [_] (nav-fn state :chronic-issues :prev))}
     (tr :ui.label/prev)]]])

(defn- statement
  [consult]
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.chronic-issues/statement (:consult/service-type consult))]]])

(defn chronic-issues-field
  [state]
  [:div.field.has-check ;; .is-horizontal
   [:div.field-label.is-normal
    [:label.label (str (tr :ui.survey.chronic-issues/question))]]
   [:div.field-body
    [:div.field ;; .is-grouped-multiline.is-grouped
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "chronic-issues"
                      :checked   (true? (get-in @state [:consult :consult/chronic-issues? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/chronic-issues? :value])
                                         new-value (when (-> e .-target .-checked) true)
                                         changed?  (or (get-in @state [:consult :consult/chronic-issues? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/chronic-issues? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/chronic-issues? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/chronic-issues? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/yes)]]]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "chronic-issues"
                      :checked   (false? (get-in @state [:consult :consult/chronic-issues? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/chronic-issues? :value])
                                         new-value (when (-> e .-target .-checked) false)
                                         changed?  (or (get-in @state [:consult :consult/chronic-issues? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/chronic-issues? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/chronic-issues? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/chronic-issues? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/no)]]]]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The chronic issues step"
  [state nav-fn]
  (let [consult (rf/subscribe [:consumer/consult])]
    [:div.card-content
    ;; statement
     [statement @consult]
    ;; field
    [chronic-issues-field state]
    [:hr]
    ;; navigation
    [navigation state nav-fn]]))
